import React, { useState, useEffect } from 'react'
import { supabase } from '../supabase'

export default function NewPieceModal({ onClose, onCreated, theme: t }) {
  const [pieceTypes, setPieceTypes] = useState([])
  const [selectedType, setSelectedType] = useState('')
  const [newTypeName, setNewTypeName] = useState('')
  const [showNewType, setShowNewType] = useState(false)
  const [date, setDate] = useState(new Date().toISOString().split('T')[0])
  const [readyForBisque, setReadyForBisque] = useState(true)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [photo, setPhoto] = useState(null)
const [photoPreview, setPhotoPreview] = useState(null)

  useEffect(() => {
    fetchPieceTypes()
  }, [])

  const fetchPieceTypes = async () => {
    const { data } = await supabase.from('piece_types').select('*').order('name')
    if (data && data.length > 0) {
      setPieceTypes(data)
      setSelectedType(data[0].name)
      setShowNewType(false)
    }
  }

  const generateUniqueId = async (type, date) => {
    const dateStr = date.replace(/-/g, '').slice(2)
    const { data } = await supabase
      .from('pieces')
      .select('day_counter')
      .eq('date_created', date)
      .order('day_counter', { ascending: false })
      .limit(1)
    const counter = data && data.length > 0 ? data[0].day_counter + 1 : 1
    return { uniqueId: `${type}${dateStr}.${counter}`, counter }
  }

  const handleCreate = async () => {
if (!selectedType && !newTypeName.trim()) { setError('Please select a piece type'); return }    setLoading(true)
    setError(null)

    try {
      const typeToUse = showNewType ? newTypeName.toLowerCase().trim() : selectedType

      if (showNewType && newTypeName.trim()) {
        await supabase.from('piece_types').upsert({ name: typeToUse })
      }

      const { uniqueId, counter } = await generateUniqueId(typeToUse, date)
      const textureIndex = Math.floor(Math.random() * 6) + 1

            const { data, error } = await supabase.from('pieces').insert({
        unique_id: uniqueId,
        type_tag: typeToUse,
        date_created: date,
        day_counter: counter,
        firing_stage: readyForBisque ? 'bisque-fire' : 'greenware',
        bisque_date: readyForBisque ? date : null,
        texture_index: textureIndex
      }).select().single()

      if (error) throw error

      if (photo && data) {
        const fileName = `${data.id}/${Date.now()}_${photo.name.replace(/[^a-zA-Z0-9._-]/g, '_')}`
        const { error: uploadError } = await supabase.storage.from('photos').upload(fileName, photo)
        if (!uploadError) {
          const { data: { publicUrl } } = supabase.storage.from('photos').getPublicUrl(fileName)
          await supabase.from('photos').insert({ piece_id: data.id, url: publicUrl, is_default: true })
          await supabase.from('pieces').update({ default_photo_url: publicUrl }).eq('id', data.id)
          data.default_photo_url = publicUrl
        }
      }

      onCreated(data)
      onClose()
    } catch (err) {
      setError(err.message)
    }
    setLoading(false)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 100 }}>
      <div style={{ background: t.card, borderRadius: '20px 20px 0 0', width: '100%', maxWidth: '430px', padding: '24px', paddingBottom: '40px' }}>

        {/* Handle */}
        <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: t.border, margin: '0 auto 20px' }}></div>

        <div style={{ fontFamily: 'Dancing Script, cursive', fontSize: '26px', fontWeight: '700', color: t.header, marginBottom: '20px' }}>New Piece</div>

        {error && (
          <div style={{ background: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '10px', padding: '10px 12px', fontSize: '12px', color: '#cc4444', marginBottom: '16px' }}>{error}</div>
        )}

        {/* Date */}
        <div style={{ marginBottom: '14px' }}>
          <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.8px', textTransform: 'uppercase', color: t.textLight, marginBottom: '5px' }}>Date</div>
          <input
            type="date"
            value={date}
            onChange={e => setDate(e.target.value)}
            style={{ width: '100%', background: t.bg, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '10px 12px', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif', boxSizing: 'border-box' }}
          />
        </div>

        {/* Type */}
        <div style={{ marginBottom: '14px' }}>
          <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.8px', textTransform: 'uppercase', color: t.textLight, marginBottom: '5px' }}>Piece Type</div>
          {!showNewType ? (
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {pieceTypes.map(pt => (
                <div key={pt.id} onClick={() => setSelectedType(pt.name)} style={{ fontSize: '11px', padding: '6px 12px', borderRadius: '12px', cursor: 'pointer', background: selectedType === pt.name ? t.header : t.bg, color: selectedType === pt.name ? '#e8f8f6' : t.text, border: `1px solid ${selectedType === pt.name ? t.header : t.border}` }}>
                  {pt.name}
                </div>
              ))}
              <div onClick={() => setShowNewType(true)} style={{ fontSize: '11px', padding: '6px 12px', borderRadius: '12px', cursor: 'pointer', background: t.bg, color: t.textLight, border: `1px dashed ${t.border}` }}>
                + new type
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                autoFocus
                value={newTypeName}
                onChange={e => setNewTypeName(e.target.value)}
                placeholder="e.g. teapot"
                style={{ flex: 1, background: t.bg, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '10px 12px', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif' }}
              />
              <div onClick={() => { setShowNewType(false); setSelectedType(pieceTypes[0]?.name || '') }} style={{ padding: '10px 12px', borderRadius: '10px', background: t.bg, border: `1px solid ${t.border}`, fontSize: '12px', color: t.textLight, cursor: 'pointer' }}>Cancel</div>
            </div>
          )}
        </div>

        {/* Ready for bisque toggle */}
        <div onClick={() => setReadyForBisque(!readyForBisque)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: t.bg, border: `1px solid ${t.border}`, borderRadius: '12px', padding: '12px 14px', marginBottom: '20px', cursor: 'pointer' }}>
          <div>
            <div style={{ fontSize: '13px', fontWeight: '400', color: t.text }}>Ready for bisque fire</div>
            <div style={{ fontSize: '10px', fontWeight: '300', color: t.textLight, marginTop: '2px' }}>Puts piece directly on the bisque shelf</div>
          </div>
          <div style={{ width: '42px', height: '24px', borderRadius: '12px', background: readyForBisque ? t.header : t.border, position: 'relative', flexShrink: 0, transition: 'background .2s' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'white', position: 'absolute', top: '2px', left: readyForBisque ? '20px' : '2px', transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }}></div>
          </div>
        </div>

                {/* Photo */}
        <div style={{ marginBottom: '14px' }}>
          <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.8px', textTransform: 'uppercase', color: t.textLight, marginBottom: '5px' }}>Photo (optional)</div>
          <label style={{ display: 'block', cursor: 'pointer' }}>
            <input type="file" accept="image/*" onChange={e => { const file = e.target.files[0]; if (file) { setPhoto(file); setPhotoPreview(URL.createObjectURL(file)) } }} style={{ display: 'none' }}/>
            {photoPreview ? (
              <img src={photoPreview} alt="" style={{ width: '100%', height: '140px', objectFit: 'cover', borderRadius: '12px', border: `1px solid ${t.border}` }}/>
            ) : (
              <div style={{ width: '100%', height: '100px', borderRadius: '12px', border: `1.5px dashed ${t.border}`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '6px', color: t.textLight, fontSize: '12px', background: t.bg }}>
                <span style={{ fontSize: '24px' }}>📷</span>
                Add photo
              </div>
            )}
          </label>
        </div>

        {/* Preview ID */}
        <div style={{ background: t.bg, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '10px 14px', marginBottom: '20px', fontSize: '11px', color: t.textLight }}>
          ID will be: <span style={{ fontFamily: 'Alike, serif', color: t.header, fontSize: '13px' }}>{showNewType ? newTypeName.toLowerCase().trim() || '?' : selectedType}{date.replace(/-/g, '').slice(2)}.#</span>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <div onClick={onClose} style={{ flex: 1, padding: '12px', borderRadius: '12px', border: `1px solid ${t.border}`, background: t.bg, fontSize: '14px', fontWeight: '400', color: t.textLight, textAlign: 'center', cursor: 'pointer' }}>Cancel</div>
          <div onClick={handleCreate} style={{ flex: 2, padding: '12px', borderRadius: '12px', background: loading ? t.border : t.header, fontSize: '14px', fontWeight: '500', color: '#e8f8f6', textAlign: 'center', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Creating...' : 'Create piece'}
          </div>
        </div>
      </div>
    </div>
  )
}